(function() {
  const variantMap = {
    'WHITE': '59269401608537',
    'YELLOW': '59269401739609',
    'RED': '59269401772377',
    'BLUE': '59269401805145'
  };

  let selectedDeal = 0; // 0 = Single, 1 = Duo
  let singleColor = 'White';
  let duoColor1 = 'White';
  let duoColor2 = 'Yellow';

  function getVariantId(colorName) {
    const c = (colorName || 'White').toUpperCase();
    return variantMap[c] || '59269401608537';
  }

  // 1. Bundle Deal Toggle
  const dealBars = document.querySelectorAll('.rapi-bundles__bar');
  dealBars.forEach((bar, idx) => {
    bar.addEventListener('click', function() {
      selectedDeal = idx;
      
      // Update radio and active classes
      dealBars.forEach((b, i) => {
        const inp = b.querySelector('input[type="radio"]');
        const container = b.querySelector('.rapi-bundles__bar-container');
        const variantsBox = b.querySelector('.rapi-bundles__bar-variants');
        if (i === idx) {
          if (inp) inp.checked = true;
          if (container) {
            container.style.boxShadow = 'rgba(255, 140, 0, 0.8) 0px 0px 0px 2px inset';
            container.style.backgroundColor = '#fffaf0';
          }
          if (variantsBox) variantsBox.style.display = 'block';
        } else {
          if (inp) inp.checked = false;
          if (container) {
            container.style.boxShadow = 'rgba(46, 46, 46, 0.48) 0px 0px 0px 2px inset';
            container.style.backgroundColor = '#ffffff';
          }
          if (variantsBox) variantsBox.style.display = 'none';
        }
      });

      // Update hero main price
      const dealPriceEl = bar.querySelector('.rapi-bundles__bar-price .money');
      const dealCompareEl = bar.querySelector('.rapi-bundles__bar-full-price .money');
      if (dealPriceEl) {
        document.querySelectorAll('.price .price-item--sale, .main-price').forEach(el => {
          el.innerHTML = dealPriceEl.innerHTML;
        });
      }
      if (dealCompareEl) {
        document.querySelectorAll('.price .price-item--regular s, .main-compare-price').forEach(el => {
          el.innerHTML = dealCompareEl.innerHTML;
        });
      }
    });
  });

  // Trigger Deal 0 by default
  if (dealBars[0]) {
    dealBars[0].click();
  }

  // 2. Swatch Selection inside deals
  document.querySelectorAll('.rapi-swatch-option').forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.stopPropagation();
      const parent = this.closest('.rapi-swatch-buttons');
      if (!parent) return;
      parent.querySelectorAll('.rapi-swatch-option').forEach(s => s.classList.remove('selected'));
      this.classList.add('selected');
      
      const span = this.querySelector('span');
      const colorVal = span ? span.getAttribute('title') : 'White';
      
      const hiddenInput = parent.parentElement.querySelector('.rapi-select-value');
      if (hiddenInput) hiddenInput.value = colorVal;
      
      // Check which camera slot this is
      const variantContainer = this.closest('.rapi-bundles__bar-variant');
      const slotNum = variantContainer ? variantContainer.querySelector('.rapi-bundles__bar-variant-number') : null;
      const num = slotNum ? slotNum.innerText.replace('#', '').trim() : '1';
      
      if (selectedDeal === 0) {
        singleColor = colorVal;
      } else {
        if (num === '1') duoColor1 = colorVal;
        else duoColor2 = colorVal;
      }
    });
  });

  // 3. Add to Cart submission
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
    const origText = submitBtn ? submitBtn.innerHTML : 'Add to cart';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span>Adding...</span>';
    }

    let items = [];
    if (selectedDeal === 0) {
      items.push({ id: getVariantId(singleColor), quantity: 1 });
    } else {
      items.push({ id: getVariantId(duoColor1), quantity: 1 });
      items.push({ id: getVariantId(duoColor2), quantity: 1 });
    }

    const currentCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const totalPrice = selectedDeal === 0 ? 34.95 : 49.98;
    const firstVid = items[0].id;

    if (typeof fbq === 'function') {
      try {
        fbq('track', 'AddToCart', {
          content_name: 'Mini Pocket Snap',
          content_ids: [firstVid],
          content_type: 'product',
          value: totalPrice,
          currency: currentCurrency
        });
      } catch(err) {}
    }

    if (typeof ttq === 'object' && typeof ttq.track === 'function') {
      try {
        ttq.track('AddToCart', {
          content_id: firstVid,
          content_type: 'product',
          quantity: items.length,
          price: 34.95,
          value: totalPrice,
          currency: currentCurrency
        });
      } catch(err) {}
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const payload = { items: items };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      payload.sections = cartDrawer.getSectionsToRender().map(s => s.section || s.id);
      payload.sections_url = (window.routes && window.routes.cart_url) || '/cart';
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(data => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = origText;
      }
      if (data.status && data.status !== 200) {
        alert(data.description || 'Could not add to cart.');
        return;
      }
      if (cartDrawer) {
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch(err => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = origText;
      }
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    });
  });

  // 4. Accordions Toggle
  document.querySelectorAll('details summary, .collapsible-trigger').forEach(el => {
    el.addEventListener('click', function(e) {
      const details = this.closest('details');
      if (details) {
        e.preventDefault();
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      }
    });
  });
})();
